import { dataProps } from './properties'

export const setShipmentPartnerList = (state, payload) => {
    state.list = payload
}

export const setShipmentPartnerData = (state, payload) => {
    state.props = payload.response
}

export const resetShipmentPartnerData = state => {
    state.props = JSON.parse(JSON.stringify(dataProps))
}


// WEBPACK FOOTER //
// ./src/store/modules/shipmentPartner/mutations.js